import React, { useEffect, useState } from "react";
import { McButton } from "@maersk-global/mds-react-wrapper";

import { AL } from "./al";
import App from "./App";
import AccessRequestForm from "./Components/AccessRequest/AccessRequestForm";
import "./authentication.css";

const Auth = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [accessRequestOpen, setAccessRequestOpen] = useState(false);

  const accessOptions = [
    {
      title: "New to Salesforce",
      actionText: "Request access",
      actionUrl: process.env.REACT_APP_SALESFORCE_ACCESS_URL,
      guideUrl: process.env.REACT_APP_SALESFORCE_NEW_ACCESS_GUIDE_URL,
    },
    {
      title: "Vestas Charge Notice Access or any other queries",
      actionText: "Request access",
      actionUrl: process.env.REACT_APP_VESTAS_TOOL_ACCESS_URL,
      guideUrl: process.env.REACT_APP_VESTAS_TOOL_GUIDE_URL,
    },
    {
      title: "Reactivate Salesforce Access",
      description:
        "For users who already have Salesforce access but have not logged in for the last 7 days.",
      actionText: "Reactivate access",
      actionUrl: process.env.REACT_APP_SALESFORCE_REACTIVATE_URL,
      guideUrl: process.env.REACT_APP_SALESFORCE_REACTIVATION_GUIDE_URL,
    },
  ];

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (AL.isTokenValid("access_token", 10000)) {
          setUser(AL.storage.id_token_claims);
        } else if (AL.isTokenValid("refresh_token", 10000)) {
          await AL.refreshTokens({});
          setUser(AL.storage.id_token_claims);
        } else {
          setUser(null);
        }
      } catch (error) {
        console.error("Auth check failed:", error);
        setUser(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  const handleSignIn = () => {
    AL.loginRedirect({
      scopes: ["openid", "profile", "email", "roles"],
    });
  };

  if (loading) {
    return (
      <div className="auth-loading">
        Loading authentication...
      </div>
    );
  }

  if (user) {
    return <App />;
  }

  return (
    <div className="mds">
      <div className="login-page">
        <div className="sign-in-card">
          <div className="sign-in-wrapper">
            <div className="sign-in-header">
              <h1 className="sign-in-title mds-headline--medium">
                Welcome to Maersk
              </h1>

              <p className="sign-in-subtitle">
                Unplanned Charges Management System
              </p>
            </div>

            <div className="sign-in-content">
              <McButton
                fit="medium"
                appearance="secondary"
                onClick={handleSignIn}
              >
                Sign In
              </McButton>

              <div className="access-instructions">
                <div className="access-header">
                  <p className="access-title">
                    Need access?{" "}
                    <span className="access-title-note">
                      To be requested by Maersk CX Agents only
                    </span>
                  </p>

                  <p className="access-subtitle">
                    Choose the option that matches your access requirement.
                  </p>
                </div>

                <div className="access-card-list">
                  {accessOptions.map((option) => (
                    <div
                      className="access-option-card"
                      key={option.title}
                    >
                      <div className="access-option-content">
                        <p className="access-option-title">
                          {option.title}
                        </p>

                        {option.description && (
                          <p className="access-option-description">
                            {option.description}
                          </p>
                        )}
                      </div>

                      <div className="access-option-actions">
                        <a
                          className="access-action-link"
                          href={option.actionUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          {option.actionText}
                        </a>

                        <a
                          className="access-guide-link"
                          href={option.guideUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          Help guide
                        </a>
                      </div>
                    </div>
                  ))}
                </div>

                <div className="access-request-footer">
                  <p className="access-note">
                    If you want to request the application access, please
                    click below and submit the details.
                  </p>

                  <button
                    type="button"
                    className="access-guide-link"
                    onClick={() => setAccessRequestOpen(true)}
                  >
                    Request Portal Access
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* The right-side image is the login-page background */}
      </div>

      <AccessRequestForm
        open={accessRequestOpen}
        onClose={() => setAccessRequestOpen(false)}
        registrationUrl={process.env.REACT_APP_CIAM_REGISTRATION_URL}
      />
    </div>
  );
};

export default Auth;